import * as v from 'valibot';

import { aircraftStatusSchema } from '#entities';

export const aircraftStatusesResponseSchema = v.object({
  /** Array of aircraft statuses */
  data: v.array(aircraftStatusSchema),
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type AircraftStatusesResponse = v.InferInput<
  typeof aircraftStatusesResponseSchema
>;
